import styled from 'styled-components'


export const Directorbackground = styled.div`

height:80vh;
background-repeat:no-repeat;
background-size:cover;
background-position:center;
display:flex;
flex-direction:column;
`
export const Directortext = styled.div`
color:white;
display:flex;
flex-direction: column;
align-self:center;
padding:200px;
// @media screen and (max-width: 768px) {
//     padding:0;
// }
`

export const Rules = styled.div`
display:flex;
flex-direction:column;
gap:40px;
padding 60px;

flex-wrap;
max-width:90%;
@media screen and (max-width:768px){
padding:10px;
}
`
export const Guidlines = styled.div`
opacity:0.6;
font-weight:600;
margin: 0; padding: 0;
text-align: left;
`
export const Leave = styled.div`
opacity:0.6;
font-weight:600;
margin: 0; padding: 0;
text-align: left;

`